<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Cómo se mide y vende cada producto. 
                Administra la unidad base y sus variantes: 
                alternativas (UMA) como caja/six pack, 
                paralela (UMP) para peso/volumen variable, 
                y de venta (UMV) usada en el documento. Úsalo para que precios, costos e inventario queden correctos.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Unidades de Medida
          </h2>
        </div>

        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>unidades de medida</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
            <!--<div class="text-3xl font-extrabold tracking-tight">Unidades de Medida</div> -->
            <!--<app-status-filters [selectedStatuses]="selectedStatuses"
            [showStatus]="[1,0]" [typeFilter]="'master'"  (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>-->
          
          <app-status-filters 
            [selectedStatuses]="selectedStatuses"
            [modeTreeUnit]="modeTreeUnit"
            [showStatus]="[1,0]" 
            [typeFilter]="'master'"
            [showTreeModeUnit]="true"
            (selectionFilterApply)="findAllWithCount()"
            (selectionFilterApplyTree)="onChangePointTree($event)">
          </app-status-filters>

        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" 
            mat-flat-button [color]="'primary'" 
            (click)="onExportButtonPressed()" 
            matTooltip="Exportar"
            >
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div *ngIf="!modeTreeUnit" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
        <!--<div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">-->
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)">
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let unit" class="text-sm uppercase leading-tight">
                  <!-- <div *ngIf="unit.externalKeys">
                    <b style="font-size: 12px;">{{ unit.externalKeys.code }}</b>
                  </div> -->
                  <div *ngIf="getCode(unit) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ unit.name }}
                </td>
              </ng-container>
              <!-- Grupo -->
              <ng-container matColumnDef="group">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupo de Unidad</th>
                <td mat-cell *matCellDef="let unit" class="text-sm uppercase leading-tight">
                  <div *ngIf="getCode(unit.group) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ unit.group?.name }}
                </td>
              </ng-container>
              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                <td mat-cell *matCellDef="let unit" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="unit.statusId == 1"
                    [(ngModel)]="unit.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, unit)">
                  </mat-slide-toggle>
                </td>
              </ng-container>
              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let unit" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(unit)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(unit)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10 bg-white dark:bg-gray-900"></tr>
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b h-16"></tr>
            </table>
          </div>
        </div>

        <!-- Main Content Tree View-->
         <div *ngIf="modeTreeUnit" class="flex flex-auto overflow-hidden flex-col">
          <!-- Tabla -->
            <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
              <!-- Header -->
              <div class="overflow-auto flex-1 dark:bg-gray-900">
                <table class="w-full bg-transparent" mat-table 
                      [dataSource]="dataSourceTree" matSort 
                      [trackBy]="trackByFn" multiTemplateDataRows>
                  <!-- Expansion Column /grupo -->
                  <ng-container matColumnDef="group">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left no-padding-cell">
                      Grupo de Unidad
                    </th>
                    <td mat-cell *matCellDef="let unit" class="text-sm uppercase leading-tight text-left no-padding-cell">
                      <div class="flex items-center">
                        <button mat-icon-button 
                        [style.visibility]="!unit?.expandable ? 'hidden' : ''"
                        [style.marginLeft.px]="unit?.levelTree * 10" (click)="treeControl.toggle(unit)">
                          <mat-icon color="primary" class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(unit) ? 'expand_more' : 'chevron_right'}}
                          </mat-icon>
                        </button>
                        <!-- Parent Node -->
                        <div *ngIf="unit.children && unit.children.length > 0 else groupInfo">
                          <span *ngIf="getCode(unit.auxUniqueGroup) as code">
                            <b>{{ code }}</b> - {{ unit.auxUniqueGroup?.name }}
                          </span>
                        </div>
                        <ng-template #groupInfo>
                          <div *ngIf="!unit.children || unit.children.length === 0 else defaultRow">
                            <div *ngIf="getCode(unit.group) as code">
                              <b class="f-10">{{ code }}</b>
                            </div>
                            {{ unit.group?.name }}
                          </div>
                        </ng-template>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Name -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                    <td mat-cell *matCellDef="let unit" class="text-sm uppercase leading-tight">
                      <div *ngIf="!unit.children || unit.children.length === 0 else defaultRow">
                        <div *ngIf="getCode(unit) as code">
                          <b class="f-10">{{ code }}</b>
                        </div>
                        {{ unit.name }}
                      </div>
                    </td>
                  </ng-container>
                  <!-- Estatus -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                    <td mat-cell *matCellDef="let unit" class="px-6 text-left">
                      <div *ngIf="!unit.children || unit.children.length === 0">
                        <mat-slide-toggle class="custom-slide-toggle primary" [checked]="unit.statusId == 1"
                          [(ngModel)]="unit.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, unit)">
                        </mat-slide-toggle>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Actions -->
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                    <td mat-cell *matCellDef="let unit" class="px-6 py-3 text-left">
                      <div *ngIf="!unit.children || unit.children.length === 0">
                        <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionMenu="matMenu">
                          <button mat-menu-item (click)="openEditModal(unit)">
                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                            <span>Editar Registro</span>
                          </button>
                          <button mat-menu-item (click)="openDeleteDialog(unit)">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                            <span>Eliminar Registro</span>
                          </button>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>
                  <!-- Header Row -->
                  <tr mat-header-row
                  *matHeaderRowDef="displayColumnsTree" 
                  class="sticky top-0 z-10 bg-white dark:bg-gray-900"
                  ></tr>
                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let row; columns: displayColumnsTree" class="border-b h-16"></tr>
                </table>
              </div>
            </div>
          </div>
          
          <!-- Paginator -->
          <div *ngIf="!modeTreeUnit" class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator 
            class="z-10" 
            [pageSizeOptions]="[50, 100, 150, 200]" 
            showFirstLastButtons [length]="totalItems"
            [pageIndex]="pageIndex" 
            [pageSize]="pageSize" 
            (page)="onPageChange($event)">
            </mat-paginator>
          </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm" class="grid grid-cols-2 gap-4 items-center">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Código</mat-label>
            <input matInput [(ngModel)]="currentCreateUnitOfMeasure.code" name="code" required>
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentCreateUnitOfMeasure.name" name="name" required>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Grupo de Unidad</mat-label>
            <mat-select [(ngModel)]="currentCreateUnitOfMeasure.groupId" name="groupId">
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchGroupUnit"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="changueOptionsGroupUnit($event)"
                    placeholderLabel="Buscar..."
                    noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>
              @for (group of groupUnitMeasurementFilterList; track group) {
              <mat-option [value]="group._id">
                <span>
                  <b *ngIf="getCode(group) as code">
                    {{ code }} -
                  </b>{{ group.name }}
                </span>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          
          <div appearance="fill" class="col-span-1">
              <span class="slide">¿Acepta decimales?</span>
              <mat-slide-toggle
              [(ngModel)]="currentCreateUnitOfMeasure.hasacceptedDecimals"
              name="hasacceptedDecimals"
              color="primary"
            >
            </mat-slide-toggle>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createUnitOfMeasure()"
          [disabled]="!createForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        
        <form #editForm="ngForm" class="grid grid-cols-2 gap-4 items-center">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Código</mat-label>
            <input matInput [(ngModel)]="currentUpdateUnitOfMeasure.code" name="code" disabled>
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentUpdateUnitOfMeasure.name" name="name" required>
          </mat-form-field>
     
          <mat-form-field appearance="fill" class="col-span-1">
            <mat-label>Grupo de Unidad</mat-label>
            <mat-select [(ngModel)]="currentUpdateUnitOfMeasure.groupId" name="groupId">
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchGroupUnit"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="changueOptionsGroupUnit($event)"
                    placeholderLabel="Buscar..."
                    noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
              </mat-option>
              @for (group of groupUnitMeasurementFilterList; track group) {
              <mat-option [value]="group._id">
                <span>
                  <b *ngIf="getCode(group) as code">
                    {{ code }} -
                  </b>{{ group.name }}
                </span>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div appearance="fill" class="col-span-1">
            <span class="slide">¿Acepta decimales?</span>
            <mat-slide-toggle
            [(ngModel)]="currentUpdateUnitOfMeasure.hasacceptedDecimals"
            name="hasacceptedDecimals"
            color="primary"
            >
            </mat-slide-toggle>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateUnitOfMeasure(currentUpdateUnitOfMeasure._id)" [disabled]="!editForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-sidenav-container>
